module.exports = __webpack_public_path__ + "static/6-107d0c535d3be5f0c2d96b15f0e63729.png";